// Copyright (c) 2019 Deere & Company

import { resetUserDealerData } from './reset-pin-transfer-data';
import { searchPinTransferData } from './search-pin-transfer-data';
import { updateTransferComment } from './comment';
import { updateTransferStatus } from './transfer-status';

export default {
    searchPinTransferData,
    resetUserDealerData,
    updateTransferComment,
    updateTransferStatus,
};
